import globalStore from '@/store/global';
import appLogger from '@public/log/monitor';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import Form from './components/form';
import List from './components/list';
import PrivateForm from './components/privateForm';
import store from './store';

const ModelManagement = observer(({ logArrt, fromTab = 20, id, item }: {
  logArrt: string;
  fromTab: number;
  id: string;
  item: any;
}) => {
  const [tabType, setTabType] = useState(fromTab);
  const tabList = globalStore.cloudConfig.assistantHomeModelTab || [
    {
      name: '大模型',
      sort: 15,
      desc: '',
    },
    {
      name: '云厂商',
      sort: 20,
      desc: '',
    },
    {
      name: '自定义模型',
      sort: 30,
      desc: '',
    },
    {
      name: '一体机',
      sort: 40,
      desc: '',
    }
  ];

  useEffect(() => {
    appLogger.log({
      key: "aibot_home",
      action: "show",
      arrt: logArrt,
    });
    store.getModelFirmList(id, fromTab);
  }, []);


  return (
    <div className='model-management flex flex-col p-24px'>
      <p className='text-24px leading-33px mb-18px font-bold'>模型管理</p>
      <div className='flex mb-16px gap-8px'>
        {
          tabList.map(item => {
            return <div className={`
              flex px-14px h-38px items-center rounded-12px font-16px cursor-pointer
              ${tabType === item.sort ? 'bg-[#000] text-[#fff] font-bold' : 'bg-[#fff] hover:bg-[rgba(0,0,0,.03)] text-[#000] border-1px border-[#000]/10'}
            `}
            key={item.sort}
            onClick={() => {
              store.setFromTab(item.sort)
              setTabType(item.sort)
              store.autoFocus();
            }}
            >{item.name}</div>
          })
        }
      </div>
      <div className='mb-12px text-[rgb(0,0,0,.5)] font-12px'>
        {tabList.find(item => item.sort === tabType)?.desc}
      </div>
      <div className='flex flex-1'>
        <List />
        {
          store.activeModel?.model_type === 3 || store.activeModel?.model_type === 4 ?
          <PrivateForm/> :
          <Form/>
        }
      </div>
    </div>
  );
});

export default ModelManagement;
